import { SVG } from '../svg';
import { IconProps } from '../types';

export function MenuIcon(props: IconProps): JSX.Element {
  return (
    <SVG {...props}>
      <line x1="4" x2="20" y1="12" y2="12" />
      <line x1="4" x2="20" y1="6" y2="6" />
      <line x1="4" x2="20" y1="18" y2="18" />
    </SVG>
  );
}
